import { Component, OnInit } from '@angular/core';
import { NavBarService } from '../../../services/nav-bar.service';
import { IconBarService } from '../../../services/icon-bar.service';
import { MenuService } from '../../../services/menu.service';
import { DataIoService } from '../../../services/data-io.service';
import { MenuNode } from '../../../classes';
@Component({
  selector: 'app-loadinganimation',
  templateUrl: './loadinganimation.component.html',
  styleUrls: ['./loadinganimation.component.scss']
})
export class LoadinganimationComponent implements OnInit {
  constructor(
  	private navBar:NavBarService,
    private iconBar:IconBarService,
  	private menuService:MenuService,
  	private ioService:DataIoService
  ){
  	
  }
  node:MenuNode=undefined;
  ngOnInit() {
  	this.node = this.menuService.getCurrentNode();
    if(this.node.hasParameter('setup')){
      this.iconBar.disableAll();
      this.navBar.disableAll();
      this.navBar.enable('installer');
    }

  }

  ngOnDestroy(){ 
  }
}
